// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"273": "ad70d6f55b68bea3","336": "1a86cb7638c0b0af",}[chunkId] + ".css"
}